import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/z.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-3bccbbe2")

_pushScopeId("data-v-3bccbbe2")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { id: "link-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", null, "Portfolio", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", null, "Blog", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  id: "logo",
  src: _imports_0
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "link",
        id: "portfolio-link",
        to: "/about"
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "link",
        id: "techblog-link",
        to: "/zerio"
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _hoisted_5
  ]))
})